export default __webpack_public_path__ + "static/timeline-955229583482c52a836b4807b94480d5.png";